"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const selectors_1 = require("@/app/shared/store/global/selectors");
const scheduler_1 = require("@/app/SUMO/components/scheduler");
const scheduler_2 = require("@/app/SUMOCEP/components/scheduler");
const progressspinner_1 = require("primereact/progressspinner");
const react_redux_1 = require("react-redux");
const SchedulerContainer = () => {
    const serverType = (0, react_redux_1.useSelector)(selectors_1.globalSelectors.selectServerType);
    if (serverType === "SUMO" /* ServerType.SUMO */)
        return (0, jsx_runtime_1.jsx)(scheduler_1.Scheduler, {});
    if (serverType === "SALESFORCE" /* ServerType.SALESFORCE */)
        return (0, jsx_runtime_1.jsx)(scheduler_2.Scheduler, {});
    return ((0, jsx_runtime_1.jsx)("div", { className: 'flex-1 flex-center h-full', children: (0, jsx_runtime_1.jsx)(progressspinner_1.ProgressSpinner, {}) }));
};
exports.SchedulerContainer = SchedulerContainer;
